export const PUBLIC_BOOKING_LEGAL_CONSENT_LABEL =
  "I agree to the Terms of Service and acknowledge the Privacy Policy.";
export const PUBLIC_BOOKING_LEGAL_CONSENT_ERROR =
  "Please agree to the Terms of Service and acknowledge the Privacy Policy before booking.";
export const PUBLIC_BOOKING_LEGAL_CONFIG_ERROR =
  "Booking is temporarily unavailable because the Terms of Service and Privacy Policy are not fully configured yet.";
export const PUBLIC_BOOKING_LEGAL_PAGE_VARIANT = "hybrid_checkout";

export type PublicBookingLegalPages = {
  termsUrl: string;
  privacyUrl: string;
  termsVersion: string;
  privacyVersion: string;
};

function normalizeLegalValue(value: unknown) {
  return String(value ?? "").trim();
}

export function resolvePublicBookingLegalPagesConfig(value: unknown): PublicBookingLegalPages | null {
  const source = value && typeof value === "object" && !Array.isArray(value) ? (value as Record<string, unknown>) : {};
  const termsUrl = normalizeLegalValue(source.termsUrl);
  const privacyUrl = normalizeLegalValue(source.privacyUrl);
  const termsVersion = normalizeLegalValue(source.termsVersion);
  const privacyVersion = normalizeLegalValue(source.privacyVersion);

  if (!termsUrl || !privacyUrl || !termsVersion || !privacyVersion) {
    return null;
  }

  return {
    termsUrl,
    privacyUrl,
    termsVersion,
    privacyVersion
  };
}

export function buildPublicBookingConsentAdminDetails(input: {
  acceptedAt: string;
  legalPages: PublicBookingLegalPages;
}) {
  return {
    consent_received: "Yes",
    consent_recorded_at: input.acceptedAt,
    terms_version: input.legalPages.termsVersion,
    privacy_version: input.legalPages.privacyVersion
  };
}

export function buildPublicBookingConsentAuditMetadata(input: {
  acceptedAt: string;
  amountDueNow: number;
  ipAddress?: string | null;
  userAgent?: string | null;
  checkboxLabel?: string;
  legalPages: PublicBookingLegalPages;
}) {
  return {
    serverTimestamp: input.acceptedAt,
    ipAddress: input.ipAddress ?? null,
    userAgent: input.userAgent ?? null,
    termsUrl: input.legalPages.termsUrl,
    privacyUrl: input.legalPages.privacyUrl,
    termsVersion: input.legalPages.termsVersion,
    privacyVersion: input.legalPages.privacyVersion,
    checkboxLabel: input.checkboxLabel ?? PUBLIC_BOOKING_LEGAL_CONSENT_LABEL,
    amountDueNow: Math.max(0, Math.round(Number(input.amountDueNow ?? 0) || 0)),
    pageVariant: PUBLIC_BOOKING_LEGAL_PAGE_VARIANT
  };
}

export function getPublicBookingSubmitLabel(
  amountDueNow: number,
  formatAmount: (value: number) => string,
  checkoutMode: "authorization" | "setup" | "payment" | "not_required" = "authorization"
) {
  if (amountDueNow <= 0) {
    return "Confirm booking";
  }
  if (checkoutMode === "setup") {
    return "Save card and book";
  }
  if (checkoutMode === "payment") {
    return `Pay ${formatAmount(amountDueNow)} and book`;
  }
  return `Authorize ${formatAmount(amountDueNow)} and book`;
}
